import React from "react";
import { useTranslation } from "react-i18next";
import { useTeacherAvailabilityStore } from "../../../../Store/GroupManagement/TeacherAvailabilityStore";

function TabelSubHeading() {
  const { data } = useTeacherAvailabilityStore();
  const { t } = useTranslation();

  return (
    <div className="buildingJournal-redhead">
      <div className="buildingJournal-redhead__item stu-num">№</div>
      <div className="buildingJournal-redhead__item room-title">
        {t("Xodimlarning F.I.Sh")}
      </div>
      {data?.columns?.map((item) => {
        return (
          <div className="week-days" key={item.key}>
            <div className="buildingJournal-redhead__item week-days-title">
              {item.verbose_name}
            </div>
            <div className="for-contain">
              {data.availability?.[0].days?.["1_3_5"].map((item, index) => {
                return <span key={index}></span>;
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default React.memo(TabelSubHeading);
